// extracted by mini-css-extract-plugin
export default {"box":"AnimatedBtn_box__+-7e4","abutton":"AnimatedBtn_abutton__regh-"};